export default __webpack_public_path__ + "static/media/downloadIcon.451fb4fc.svg";